<div class="form-group">
  <label
    class="form-control-label"
    jhiTranslate="entredaApp.roleAttributeRoles[name]"
    *ngIf="label !== ''"
    [for]="id"
    >{{ label }}
    <span class="red" [hidden]="!required || readOnly">*</span></label
  >
  <custom-tooltip
    *ngIf="label !== ''"
    [toolTipMessage]="toolTipMessage"
    [placement]="placement"></custom-tooltip>
  <ng-select
    [items]="list"
    [name]="name"
    [id]="id"
    [(ngModel)]="selected"
    [required]="required"
    (change)="onChange($event)"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [ngClass]="{ 'min-width-1': minWidth === '1' }"
    [disabled]="readOnly"
    [clearable]="clearable"
    #selectDropDown></ng-select>
  <div [hidden]="!(control?.dirty && control?.invalid)">
    <label
      class="form-text text-danger"
      [hidden]="!control?.errors?.required"
      jhiTranslate="entity.validation.required">
      {{ label }} field is required.
    </label>
  </div>
</div>
